import { combineEpics } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { ApiError } from '@bolteu/react-api-gateway/es';

import { GlobalAppActions } from 'rdx/actions';
import { AppServices } from 'rdx/middleware';
import { GlobalAppState } from 'rdx/state';

import {
  requestRequestResetPasswordAsyncAction,
  requestSetNewPasswordAsyncAction,
} from './actions';

const requestResetPasswordEpic = (
  action$: Observable<GlobalAppActions>,
  _state$: Observable<GlobalAppState>,
  { apiClient, bugsnag }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(requestRequestResetPasswordAsyncAction.request)),
    switchMap((action) => {
      return from(apiClient.session.publicRequestResetPassword(action.payload)).pipe(
        switchMap((res) => {
          return of(requestRequestResetPasswordAsyncAction.success(res));
        }),
        catchError((e) => {
          if (!ApiError.isApiError(e)) {
            bugsnag.notify(e);
          }
          return of(requestRequestResetPasswordAsyncAction.failure(e));
        }),
      );
    }),
  );
};

const resetPasswordEpic = (
  action$: Observable<GlobalAppActions>,
  _state$: Observable<GlobalAppState>,
  { apiClient, bugsnag }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(requestSetNewPasswordAsyncAction.request)),
    switchMap((action) => {
      return from(apiClient.session.publicResetPassword(action.payload)).pipe(
        switchMap((res) => {
          return of(requestSetNewPasswordAsyncAction.success(res));
        }),
        catchError((e) => {
          if (!ApiError.isApiError(e)) {
            bugsnag.notify(e);
          }
          return of(requestSetNewPasswordAsyncAction.failure(e));
        }),
      );
    }),
  );
};

export const passwordEpic = combineEpics(requestResetPasswordEpic, resetPasswordEpic);
